import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24DownvoteFill = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M2.544 13.69a2.9 2.9 0 0 0 2.37 1.23h4.19l-1.33 3.56c-.29.767-.255 1.62.1 2.36.316.676.9 1.19 1.61 1.42a2.83 2.83 0 0 0 3.13-1l4.84-6.36h2.94a.81.81 0 0 0 .81-.81V3.81a.81.81 0 0 0-.81-.81H5.684a.94.94 0 0 0-.87.6l-2.64 7.42a2.88 2.88 0 0 0 .37 2.67m15.26-9.29h2v9.1h-2z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24DownvoteFill$1 = Svg24DownvoteFill;

export { Svg24DownvoteFill$1 as default };
